import {InMemoryAsyncDataSource as JsInMemoryAsyncDataSource} from "./ManualPagedTable";

// alias to avoid naming collisions between these and ManualPagedTable.js files.
// FIXME AsyncDataSource should be renamed directly to IAsyncDataSource when kh2 and kh3 versions are not gonna be merged anymore
export type IAsyncDataSource<T> = AsyncDataSource<T>;

export interface AsyncDataSource<T> {
    values(page: number, limit: number): Promise<T[]>
}

export class InMemoryAsyncDataSource<T> extends JsInMemoryAsyncDataSource implements AsyncDataSource<T> {
    constructor(data: (readonly T[]) | (() => Promise<T[]>)) {
        super(data);
    }

    async values(page: number, limit: number): Promise<T[]> {
        return super.values(page, limit);
    }
}
